export default () => ({
  reset: {
    token: null,
    password: null,
    password_confirmation: null
  },
  loading: false,
  onCancel: false,
  fullPage: true,
  msg: null
})



// WEBPACK FOOTER //
// ./src/app/auth/reset/resources/data.js